import { createTheme } from '@mui/material/styles'
import { PALETTE } from '@fedsim/constants'
import { emphasize } from '@mui/material/styles';
import { fontFamilies } from '@fedsim/constants'
import { BORDERRADIUS } from "@fedsim/constants"

const borderRadius = BORDERRADIUS

export const Theme = createTheme({
  components: {
    MuiCardContent: {
      styleOverrides: {
        root: () => ({
          boxShadow: 'none',
          '&:last-child': {
            paddingBottom: '4px'
          }
        })
      }
    },
    MuiStack: {
      defaultProps: {
        useFlexGap: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => {
          const lineHeight = ownerState.size === 'small' ? '1.2rem' : null
          const fontSize = ownerState.size === 'small' ? '14px' : '16px'
          let backgroundColor =
            ownerState.color === 'success'
              ? '#10a010'
              : ownerState.color === 'error'
                ? '#ae4848'
                : ownerState.color === 'info'
                  ? '#3f5a9d'
                  : 'rgb(24 12 12 / 60%)'

          return {
            fontFamily: fontFamilies.buttonFont,
            fontSize,
            fontWeight: 'light',
            textTransform: 'none',
            boxShadow: '4px 4px #8d8d8d54',
            width: 'auto',
            minWidth: 75,
            borderRadius,
            backgroundColor,
            lineHeight,
            '&:hover': {
              backgroundColor: emphasize(backgroundColor, 0.05),
              filter: 'contrast(1.5)',
              boxShadow: '5px 5px #8d8d8d58',
            }
          }
        }
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: () => ({
          borderColor: PALETTE.DIVIDER,
        })
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: () => ({
          borderRadius,
          overflow: 'hidden',
        }),
        select: () => ({
          borderRadius,
          overflow: 'hidden',
        })
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState }) => {
          return {
            borderRadius,
            boxShadow: '5px 5px #8d8d8d54',
            color: 'white',
            backgroundColor:
              ownerState?.severity === 'info'
                ? `#2d4590`
                : ownerState?.severity === 'error'
                  ? '#ae4848'
                  : '#228b22',
            '& svg': {
              fill: 'white'
            }
          }
        }
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: () => ({
          border: 'none',
          // borderRadius,
          // borderColor: '#272831',
          // boxShadow: '2px 2px #797a84',
          // height: '45px',
          // lineHeight: '45px'
        })
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: () => ({
          backgroundColor: 'rgba(0,0,0,0.5)',
          color: 'white'
        })
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: () => ({
          padding: '4px'
        })
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: () => ({
          padding: '8px 12px'
        })
      },
    },
    MuiChip: {
      styleOverrides: {
        root: () => ({
          color: 'currentcolor',
          borderRadius,
          justifyContent: 'space-between',
          // border: 'none',
        }),
        avatar: () => ({
          color: 'currentcolor'
        })
      },
    }
  },
  palette: {
  //   error: {
  //     main: '#b24343'
  //   },
    primary: {
      main: PALETTE.CONTENTAREA,
    },
    secondary: {
      main: PALETTE.HIGHLIGHT,
    },
    background: {
      paper: PALETTE.PAPER,
    }
  }
})

export default Theme
